/*  ========================================================================
    # Component - Gallery
    ========================================================================  */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LazyImage from '../LazyImage';
import { useSwipeable } from 'react-swipeable';
import useSVGSprite from '../../hooks/useSVGSprite';
import useTranslation from '../../hooks/useTranslation';

const Gallery = ({ gallery }) => {
  const __ = useTranslation();
  const [activeSlide, setActiveSlide] = useState(0);

  // Icons
  const sprite = useSVGSprite();
  const arrowRight = `${sprite}#chevron-right`;

  // Get the slide offset value.
  const getSlideOffset = index => {
    const delta = index - activeSlide;

    if (delta > 1) return 1;
    else if (delta < -1) return -1;
    // Calculate the offset - 0 for active slide, negative for previous slides, positive for next slides
    return delta;
  };

  // Navigate Left
  const navigateLeft = () => {
    if (activeSlide > 0) setActiveSlide(activeSlide - 1);
  };

  // Navigate Right
  const navigateRight = () => {
    if (activeSlide < gallery.length - 1) setActiveSlide(activeSlide + 1);
  };

  // Add swipe handlers.
  const swipeHandlers = useSwipeable({
    onSwipedRight: navigateLeft,
    onSwipedLeft: navigateRight
  });

  return (
    <>
      <div className="c-gallery__wrapper" {...swipeHandlers}>
        {gallery.map((item, index) => (
          <div
            className="c-gallery__item"
            key={`${item.title}-${index}`}
            style={gallery.length === 1 ? { opacity: 1 } : {}}
            data-offset={gallery.length === 1 ? '' : getSlideOffset(index)}
          >
            <LazyImage
              defaultUrl={item.sizes['large']}
              alt={item.alt}
              caption={item.caption}
              className="c-gallery__image"
            />
          </div>
        ))}
      </div>

      {/* Progress bar */}
      {gallery.length > 1 && (
        <div className="c-gallery__controls">
          <div className="c-gallery__progress">
            <div
              className="c-gallery__progress-bar"
              data-position={activeSlide}
              style={{
                width: `${(1 / gallery.length) * 100}%`,
                marginLeft: `${(activeSlide / gallery.length) * 100}%`
              }}
            />
          </div>
          <button
            className="c-button c-button--icon c-gallery__button c-gallery__button--left"
            aria-label={__('gallery-navigate-left')}
            onClick={navigateLeft}
          >
            <i className="u-icon u-icon--chevron-right"></i>
          </button>
          <button
            className="c-button c-button--icon c-gallery__button c-gallery__button--right"
            aria-label={__('gallery-navigate-right')}
            onClick={navigateRight}
          >
            <i className="u-icon u-icon--chevron-right"></i>
          </button>
        </div>
      )}
    </>
  );
};

Gallery.propTypes = {
  gallery: PropTypes.array
};

export default Gallery;
